export const resources = {
  en: {
    account: {
      changePassword: {
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        newPasswordRepeated: 'Repeat New Password',
        success: 'Password updated.',
        title: 'Change Password',
        errors: {
          currentPassword: 'Current Password is required',
          newPassword: 'New Password is required',
          newPasswordRepeated: {
            required: 'Repeat New Password is required',
            noMatch: 'New Passwords must match',
          },
        },
      },
      sso: {
        google: {
          login:
            "We're syncing your classes and students with Google Classrooms. Please refresh the Classes page in a couple of minutes to make sure your roster is up-to-date.",
        },
      },
    },
    app: {
      home: 'Home',
      loading: 'Loading',
      mobileSplashScreen: {
        button_1: 'Book a 15-minute chat',
        button_2: 'Teacher Resources',
        button_3: 'Student Demo',
        button_4: 'Join our Facebook Group',
        continue: 'Continue Anyway',
        text1:
          'For the best experience please login to Get More Math using a laptop or desktop.',
        text2: 'Other helpful resources.',
      },
      refresh: 'Refresh',
      navbar: {
        changePassword: 'Change Password',
        checklist: 'My To-Do List',
        classes: 'Classes',
        copyToClipboard: 'Copy to clipboard',
        gmmLogo: 'GMM Logo',
        gmmVersion: 'GMM Version',
        logout: 'Logout',
        reports: 'Reports',
        students: 'Students',
        userMenu: 'User Menu',
        work: 'Work',
        gmmAcademy: 'Help Videos',
        teacherResources: 'Teacher Resources',
        helpArticles: 'Help Articles',
        trainerSettings: 'Trainer Settings',
      },
      buttons: {
        accept: 'Accept',
        allow: 'Allow',
        archive: 'Archive',
        assign: 'Assign',
        back: 'Back',
        cancel: 'Cancel',
        clear: 'Clear',
        close: 'Close',
        create: 'Create',
        confirm: 'Confirm',
        continue: 'Continue',
        copy: 'Copy',
        deny: 'Deny',
        done: 'Done',
        dontCancel: "Don't Cancel",
        goBack: 'Go Back',
        immediate: 'Immediate',
        moreActions: 'More Actions',
        next: 'Next',
        no: 'No',
        ok: 'OK',
        print: 'Print',
        refresh: 'Refresh',
        remove: 'Remove',
        save: 'Save',
        select: 'Select',
        send: 'Send',
        set: 'Set',
        skip: 'Skip',
        submit: 'Submit',
        update: 'Update',
        verify: 'Verify',
        view: 'View',
        yes: 'Yes',
      },
      error: {
        invalidEmail: 'Invalid email address',
        snackbar: 'Something went wrong! Please try again.',
        notFound: {
          header: "We can't seem to find the page you are looking for.",
          body: 'Maybe try something else?',
        },
        codeUpdate: 'A new version of GMM is available',
      },
      labels: { beta: 'BETA', new: 'NEW!' },
      navigator: {
        folder: 'Folder',
        assignment: '$t(common:assignment)',
        exam: 'Exam',
      },
      statusTable: {
        displayOptions: 'Display Options',
        firstLast: 'First Last',
        lastFirst: 'Last, First',
      },
      unsavedChanges: {
        title: 'Unsaved Changes',
        message: 'You have unsaved changes left.',
        continue: 'Continue',
        goBack: 'Go Back',
      },
      retry: 'Retry',
      undo: 'Undo',
      minute: '{{count}} minute',
      minute_plural: '{{count}} minutes',
      copyToClipboard: {
        success: 'Copied!',
        tooltip: 'Click to copy to Clipboard',
      },
      errorTryRefresh: 'Something went wrong. Try refreshing.',
      onboardingChecklist: {
        header: 'To-Do List',
        action_video: 'Video',
        action_article: 'Article',
      },
      classLink: {
        copy: 'Copy Class Link',
        copied: 'Link Copied!',
        disableError:
          'There was an error disabling the Class Link.  Please try again',
        enableError:
          'There was an error enabling the Class Link.  Please try again',
        label: 'Students can create accounts from the link',
        title: 'Class Enrollment Link',
      },
      verifyEmail: {
        emailCaption: 'We will send a verification code to your email.',
        emailLabel: 'Email',
        emailPlaceholder: 'Enter your school email',
        emailSchoolValidationMessage:
          'That doesn’t look like a school email address.',
        emailValidationMessage: 'That doesn’t look like a valid email',
        previouslyVerified:
          'You’ve already verified your school email address and joined your school.  You’re all set.',
        resentToken: 'Verification email has been resent.',
        sendToken: 'Send Code',
        successMessage: 'We have successfully verified your email address!',
        title: 'Verify School Email Address',
        tokenCaption1:
          'Did not receive the code? Check your junk folder or <button>Resend code</button>',
        tokenCaption2: 'Need help? <button>Contact us</button>',
        tokenLabel: 'Verification Code',
        tokenPlaceholder: '123456',
        tokenSubtitle:
          'We’re sending your code.  It should arrive in your email in the next couple of minutes.',
        usernameChangeMessage:
          'This email will become your new login username.',
      },
      extendTrial: {
        emailLabel: "Admin's Email",
        emailPlaceholder: "Enter your admin's email",
        firstNameLabel: 'Admin’s First Name',
        firstNamePlaceholder: 'First name',
        formSubtitle:
          'Let us connect with your administrator to explore your options',
        lastNameLabel: 'Admin’s Last Name',
        lastNamePlaceholder: 'Last name',
        successMessageFirst:
          'Thank you!  We’ll be in touch with your administrator soon.',
        successMessageSecond:
          "If this is your first time referring your administrator, we'll add 30 days to your free trial.",
        title: 'Extend Your Free Trial',
        unverifiedSubtitle:
          'Thank you for your interest in Get More Math! Please complete the following to request a one year pilot.',
        whatForTooltip:
          'To review the terms of the pilot partnership, our team needs to contact your Administrator.',
      },
      findSchool: {
        alreadyClaimed:
          'You’ve already claimed a school. If you need choose a different school, please contact support using Intercom in the lower right-hand corner.',
        city: 'School city',
        errors: {
          invalidEmailDomain:
            'Please <updateEmail>update your email address</updateEmail> to the one provided by your school to complete this step.',
        },
        homeschool: "I'm a homeschooler",
        name: 'School name',
        other: 'Other school or organization',
        school: 'School/District',
        state: 'School state',
        submit: 'Submit',
        success: {
          homeschool:
            'Thank you for your interest in Get More Math!  We’ll send you more information about using Get More Math as a homeschooler by email.',
          other:
            'Thank you for telling us about your school!  We’re locating your school and we’ll be in touch by email within a few days.',
          school: 'Success! You are now a part of {{name}}!',
        },
        suspectEmail:
          'Thank you for choosing your school.  We’ll be reaching out in the next couple of days to finalize your selection.',
        title: 'Select Your School',
        unverified:
          'You must verify your email address before selecting a school.',
        website: 'School website',
        zip: 'School zip code',
      },
      icons: { individualMixedReview: 'In $t(common:modifiedMixedReview)' },
      logo: 'GMM Logo',
      accountStatusBar: {
        headline_trial_no_quote:
          'Your free trial ends on {{displayDate}}. You have {{daysLeft}} days remaining.',
        headline_trial_quoted:
          "We sent your school a quote, now it's time to place an order! Your free trial ends on {{displayDate}}.",
        headline_trial_invoiced:
          "Thank you for your order. We're awaiting payment. Your free trial ends on {{displayDate}}. You have {{daysLeft}} days remaining.",
        headline_pilot_no_quote:
          'Would you like a quote for next year? Your pilot ends on {{displayDate}}.',
        headline_pilot_quoted:
          'We sent your school a quote.  Place your order soon.  Your pilot ends on {{displayDate}}.',
        headline_pilot_invoiced:
          'Thank you for your order! To continue uninterrupted service, payment is due by {{displayDate}}.',
        headline_paid_no_quote:
          'Would you like a quote for next year? Your license ends on {{displayDate}}.',
        headline_paid_quoted:
          'Place your order soon! Your license ends on {{displayDate}}. You have {{daysLeft}} days remaining.',
        headline_paid_invoiced:
          'Thank you for your order! We are awaiting payment. To continue uninterrupted service, payment is due by {{displayDate}}.',
        link_trial_no_quote: 'Add more days.',
        link_trial_quoted: 'Talk to us.',
        link_trial_invoiced: 'Talk to us.',
        link_pilot_no_quote: 'Request a quote.',
        link_pilot_quoted: 'Talk to us.',
        link_pilot_invoiced: '',
        link_paid_no_quote: 'Request a quote.',
        link_paid_quoted: 'Talk to us.',
        link_paid_invoiced: '',
        link_nonStandardAccount: 'Discuss licensing options',
      },
      longLoading: {
        skillDiscovery: {
          value_0: 'Loading your selection',
          value_1: 'This may take a few moments',
          value_2: 'Thank you for your patience',
        },
        usageReports: {
          value_0: 'Loading your report',
          value_1: 'This may take a few moments',
          value_2: 'Thank you for your patience',
        },
      },
      lazySubjectModal: {
        title: 'Select a class subject',
        primaryDescription:
          'In order to sync, please configure a subject for your class.',
        secondaryDescription:
          'Please choose a subject / grade level from the drop down below.',
        tertiaryDescription: 'Once completed, please sync your class again.',
        note: 'Note: You can always change the subject / grade level in class settings.',
      },
    },
    auth: {
      emptyState: {
        headline: 'We had some trouble logging you in.',
        subheading: "Let's get you squared away. <0>Login</0>",
      },
    },
    banner: {
      examRequest: {
        content:
          '<0>{{studentName}}</0> wants to begin {{examName}} for {{className}}.',
        turnOnAutoAccept: 'Turn on Auto-Accept for {{minutes}}',
        snackbar: {
          success:
            '<0>{{studentName}}</0> was allowed to begin {{examName}} for {{className}}.',
          success_deny:
            '<0>{{studentName}}</0> was denied to begin {{examName}} for {{className}}.',
          success_autoAccept:
            'Student requests to begin {{examName}} in {{className}} will be automatically accepted for the next {{minutes}}.',
          error:
            'There was an error allowing <0>{{studentName}}</0> to begin {{examName}} for {{className}}.',
          error_deny:
            'There was an error notifying <0>{{studentName}}</0> to wait for {{examName}} for {{className}}.',
          error_autoAccept:
            'There was an error turning on Auto-Accept for {{examName}} in {{className}}.',
        },
      },
      examUnlockRequest: {
        content:
          '<0>{{studentName}}</0> wants to continue working on previously seen or answered problems from {{examName}} for {{className}}.',
        snackbar: {
          success:
            '<0>{{studentName}}</0> was allowed to continue working on previously seen or answered problems from {{examName}} for {{className}}.',
          success_deny:
            '<0>{{studentName}}</0> was not allowed to continue working on previously seen or answered problems from {{examName}} for {{className}}.',
          error:
            'There was an error allowing <0>{{studentName}}</0> to continue working on previously seen or answered problems from {{examName}} for {{className}}.',
        },
      },
    },
    classAssignments: {
      assignmentLiveMessage:
        '{{className}} is now practicing {{assignmentName}}.',
      assignmentLiveMessage_newSpiralReviewSkills:
        '{{className}} is now practicing {{assignmentName}}. New Skills were added to Spiral Review.',
      confirmDeleteModal: {
        body_released:
          'You are about to remove {{assignmentName}} from this Class. The completion report will no longer be available and your students will not be able to work on this $t(common:assignment). Do you want to proceed?',
        body_notReleased:
          'You are about to remove {{assignmentName}} from this Class. Do you want to proceed?',
        error:
          'There was an error removing your $t(common:assignment). Please try again.',
        removeSkillsCheckbox:
          'Also remove this $t(common:assignment)’s $t(common:skill_plural) from Spiral Review.',
        success: '{{assignmentName}} was removed.',
        title: 'Remove {{assignmentName}}',
        undoError:
          'There was an error undoing the removal of your $t(common:assignment).',
      },
      detail: {
        assignedAt: 'Date Assigned',
        complete: 'Complete',
        errorsFixed: 'Errors Fixed',
        goal: 'Goal: {{goal}}',
        loadError:
          'There was an error loading the results for this $t(common:assignment). Please try again.',
        newSkills: 'Targeted $t(common:skill_plural)',
        pointsEarned: 'Points Earned',
        pointsRequired: '$t(common:assignment) Points',
        spiralReview: '$t(common:mixedReview)',
        studentsCompleted: 'Students Completed',
        studentName: 'Name',
        total: 'Total',
      },
      list: {
        availableAriaLabel: 'Available toggle switch for {{assignmentName}}',
        checkboxAriaLabel: 'Default checkbox for {{assignmentName}}',
        emptyState: {
          headline: 'Manage your $t(common:assignment_plural)',
          subheading:
            'You will be able to determine which $t(common:assignment_plural) your students can choose from and which one they see first when they log in.',
        },
        table: {
          columns: {
            available: 'Available',
            available_helperText:
              'Your students can choose to work on any available Assignments they have not completed.',
            name: '$t(common:assignment) Name',
            studentsCompleted: 'Students Completed',
            isDefault: 'Default',
            isDefault_helperText:
              'The $t(common:assignment) your students will be presented with upon login.',
            releaseDate: 'Release Date',
          },
        },
        updateAvailableError:
          'There was an error changing the availability of your $t(common:assignment). Please try again.',
        updateDefaultError:
          'There was an error in changing the default $t(common:assignment). Please try again.',
        updateError:
          'There was an error updating the $t(common:assignment_plural) setting. Please try again.',
      },
      table: { name: 'Selected Class Assignment' },
    },
    classItem: {
      expanded_true: 'Minimize Class Navigation',
      expanded_false: 'Maximize Class Navigation',
      classNav: 'Class Navigation',
      navigator: {
        assignments: '$t(common:assignment_plural)',
        currentStatus: 'Current Status',
        mixedReview: 'Spiral Review',
        exams: 'Exams',
        practiceHistory: 'Practice History',
        pointsHistory: 'Points History',
        students: 'Student Data',
        reports: 'Reports',
        roster: 'Roster',
        settings: 'Settings',
      },
      status: {
        assignment: 'Assign Work',
        available: 'Available $t(common:assignment_plural):',
        mixedReview: 'Switch to Spiral Review',
      },
      todaysGoal: {
        cancel: 'Cancel',
        errorText: 'Invalid number',
        label: "Today's Goal",
        removeGoalText: 'Remove Goal',
        saveGoal: 'Save Goal',
        setGoalText: 'Set Daily Goal',
        updateSuccess: 'Updated Daily Goal',
        withValue: "Today's Goal: {{value}}",
      },
      archiveSuccess: 'Successfully archived class',
      renameSuccess: 'Successfully renamed class',
      messageClass: {
        label: 'Message Class',
        cancel: 'Cancel',
        send: 'Send',
        sent: 'Message Sent',
      },
      archivedModal: {
        title: 'Class Archived',
        body1:
          'The class you are viewing has been archived. Click below to refresh your Classes list.',
        body2: 'If you think this is an error, please contact support.',
      },
      studentRemovedModal: {
        title: 'Student Removed from Class',
        body1:
          'The student you are viewing is no longer part of this class. Click below to return to the summary page.',
        body2: 'If you think this is an error, please contact support.',
      },
    },
    classList: {
      classList: 'Class List',
      createClass: 'Create Class',
      divider: 'My Colleagues Classes',
      emptyState: {
        headline: 'No Active Classes',
        local: {
          subheading:
            'You do not have any active classes. Click “Create Class” to get started.',
        },
        google: {
          subheading:
            'You do not have any active classes. Click “Import Class“ to get started.',
        },
        clever: {
          subheading:
            'You do not have any active classes. Please confirm that you have classes in your rostering provider.',
        },
        classlink: {
          subheading:
            'You do not have any active classes. Please confirm that you have classes in your rostering provider.',
        },
      },
      expanded_true: 'Minimize Class List',
      expanded_false: 'Maximize Class List',
      importClass: 'Import Class',
    },
    classSettings: {
      addCoteachers: 'Add Co-Teachers',
      archive: 'Archive',
      archiveDisabled: 'Unable to archive as a Co-Teacher',
      archiveDialog: {
        content: 'Are you sure you wish to archive this class?',
        title: 'Archive Class',
      },
      assignmentSettings: {
        title: 'Assignment Settings',
        finishTargetedSkills:
          'Require students to finish Targeted skills before working on Spiral Review skills',
        finishDefaultAssignment:
          'Require students to finish the default Assignment before choosing other work',
      },
      coteachers: {
        addedOrRemoved:
          'You have been {{status}} as a Co-Teacher to {{className}} by <0>{{firstInitial}}.{{lastName}}</0>.',
        alert1:
          'Co-Teachers will have access to this class and all its views and settings.',
        alert2:
          'Co-Teachers will not be able to rename/archive this class or add/remove other Co-Teachers.',
        emptyState: {
          line1:
            'Once teachers from your school sign up and join your school, you will be able to add them as a co-teacher.',
          line2: 'They can use the link below to create an account.',
        },
        missingSchool: {
          alert: 'Select your school to start using Co-Teachers',
          button: 'Select Your School',
        },
        removeDialog: {
          text: 'Are you sure you wish to remove {{teacherName}} as a co-teacher?',
          title: 'Remove Co-Teacher',
        },
        title: 'Co-Teachers',
      },
      leaveClass: 'Leave Class',
      leaveDialog: {
        content: 'Are you sure you wish to leave this class?',
        title: 'Leave Class',
      },
      games: {
        label: { main: 'Points to Earn Game Credit' },
        options: {
          bergBuilder: 'Berg Builder',
          desertRace: 'Desert Race',
          invade: 'Invade',
          missileDefense: 'Missile Defense',
          spaceFlappy: 'Space Flappy',
          threeSeven: 'Three Seven',
        },
        title: 'Student Games',
      },
      other: {
        dollarsOnly:
          'Students can only work on $t(common:skill_plural) worth a point',
        examsOnMobile: 'Students can access Exams on mobile devices',
        title: 'Other',
      },
      questionTypes: {
        helperText:
          'Disabled question types will not show up for the student but they will continue to be visible for you',
        title: 'Question Types',
        options: {
          OTHER: 'Other',
          MULTI_SELECT: 'Multiselect',
          MATCH_TABLE: 'Match Table Grid',
          FRACTION_MODEL: 'Fraction Model',
          INLINE_CHOICE: 'Inline Choice',
          DRAG_AND_DROP: 'Drag and Drop',
          HOT_SPOT: 'Hot Spot',
        },
      },
      rename: 'Rename',
      renameDialog: { label: 'New Class Name', title: 'Rename Class' },
      renameDisabled: 'Unable to rename as a Co-Teacher',
      replacements: {
        description: 'Problem Replacements Per Day',
        disabledTooltip:
          '{{name}} is using the class setting for replacements. Click `Individualize` to create a custom setting.',
        inputLabel: 'Replacements',
        title: 'Problem Replacements',
        toggleLabel: 'Students can replace problems when teacher is online',
        tooltip:
          'Number of problems a student can replace in one day. Replacement creates a new problem and eliminates penalties for that problem. Maximum: {{max}}.',
      },
      studentHelp: {
        title: 'Student Help',
        readAloud: "Students can access 'read aloud'",
        requestHelp: "Students can digitally 'raise hand'",
      },
      success: 'Settings Updated',
      unsavedChanges: {
        affirmative: 'Discard',
        message: 'There are unsaved changes to the class settings.',
        negative: 'Cancel',
        title: 'Unsaved Changes',
      },
    },
    common: {
      assignment: 'Assignment',
      assignment_plural: 'Assignments',
      class: 'Class',
      class_plural: 'Classes',
      day: 'day',
      day_plural: 'days',
      exam: 'Exam',
      exam_plural: 'Exams',
      exercise_assignment: '$t(common:assignment)',
      exercise_assignment_plural: '$t(common:assignment_plural)',
      exercise_exam: '$t(common:exam)',
      exercise_exam_plural: '$t(common:exam_plural)',
      exercise_examtemplate: '$t(common:exam)',
      exercise_examtemplate_plural: '$t(common:exam_plural)',
      folder: 'Folder',
      folder_plural: 'Folders',
      mixedReview: 'Spiral Review',
      modifiedMixedReview: 'Modified Spiral Review',
      skill: 'Skill',
      skill_plural: 'Skills',
      student: 'Student',
      student_plural: 'Students',
      student_plural_lowercase: 'students',
      subject: 'Subject',
      subject_plural: 'Subjects',
      targeted_skill: 'Targeted Skill',
      targeted_skill_plural: 'Targeted Skills',
      teacher: 'Teacher',
      teacher_plural: 'Teachers',
    },
    createClass: {
      title: 'Create a class',
      className: 'Class Name',
      cancel: 'Cancel',
      saveClass: 'Save Class',
      mixedReviewBundle: {
        title: '$t(common:mixedReview) Starter Bundle',
        bullet1:
          'Your students will start with these precursor skills in $t(common:mixedReview).',
        bullet2:
          'These skills are easy and fast so your students can learn the system.',
        bullet3:
          'New skills will be automatically added when you give $t(common:assignment_plural).',
      },
    },
    createStudents: {
      title: '$t(roster:add-students) – Create Students',
      buttons: { addAnother: 'Add Another' },
      inputs: {
        firstName: 'First Name',
        lastName: 'Last Name',
        studentId: 'Student ID',
        class: 'Class',
      },
      confirmStudents: {
        title: '$t(roster:add-students) – Confirm New Students',
        table: {
          firstName: 'First Name',
          lastName: 'Last Name',
          studentId: 'Student ID',
          class: 'Class',
          username: 'Username',
        },
      },
      duplicateStudents: {
        title: '$t(roster:add-students) – Duplicate Students Found',
        existingStudents: 'Existing Students',
        studentsToAdd: 'Students to Add',
        table: {
          firstName: 'First Name',
          lastName: 'Last Name',
          studentId: 'Student ID',
        },
      },
      formHeader: 'Student {{index}}',
      summary: {
        none: '-None-',
        title: '$t(roster:add-students) – New Students Created',
        addToClassError:
          'We were unable to add some students to their classes, this can be done manually later.',
        csvFilename: 'students.csv',
        table: {
          firstName: 'First Name',
          lastName: 'Last Name',
          studentId: 'Student ID',
          class: 'Class',
          username: 'Username',
          password: 'Password',
        },
      },
      errors: {
        duplicateStudentId: 'This ID has been entered more than once.',
        invalidStudentId: 'Alphanumeric characters only',
      },
      unsavedChanges: {
        title: 'Cancel Student Creation',
        message: 'This will cancel the creation of new student accounts.',
        negative: "Don't Cancel",
        affirmative: 'Cancel',
      },
    },
    currentStatus: {
      studentName: 'Name',
      offline: 'Offline',
      online: 'Online',
      mode: 'Working On',
      pointsToday: 'Points Today',
      lastCorrect: 'Time Since Correct',
      helpOrder: 'Help Order',
      mixedReview: 'Spiral Review',
      clearHelpSuccess: 'Successfully cleared help',
      clearHelp: 'Clear help',
      displayName: { firstLast: 'First, Last', lastFirst: 'Last, First' },
      emptyState: {
        headline: 'Add students to your class to get started.',
        subheading:
          'You can add students to your class using the Roster tab on the left.',
      },
      table: { name: 'Current Status' },
    },
    examAnalysis: {
      createAssignment: 'Create $t(common:assignment)',
      selectSkills: 'Select one or more Skill first',
      table: {
        columns: {
          description: 'Description',
          numMissedStudents: 'Students Missed',
          numMissedStudents_helperText:
            'The total number of students in your class who answered this skill incorrectly.',
          numMissedPoints: 'Points Missed',
          numMissedPoints_helperText:
            'The total number of points missed by your class on this Skill, including partial credit.',
        },
      },
      title: 'Problems',
    },
    examCorrections: {
      status_COMPLETED: 'Finished',
      status_IN_PROGRESS: 'Incomplete',
      status_NOT_APPLICABLE: 'N/A: Perfect exam',
      status_NOT_AVAILABLE: 'Exam not graded',
      examCorrections: 'Exam Corrections',
      practicePoints: 'Points From Similar Problems',
      settingsHeader: 'For each error on a graded exam, the student needs to:',
      settings1: '1) Fix the error.',
      settings2Start: '2) Earn',
      settings2End: 'additional point on a similar problem.',
      settings2End_plural: 'additional points on a similar problem.',
    },
    exams: {
      autoUnlock: {
        checkboxLabel: 'Prevent $t(common:exam) problems from being locked',
        error:
          'There was an error changing your $t(common:exam) setting. Please try again.',
        tooltip:
          "'Unlocks' previously seen or answered $t(common:exam) problems so that your students can continue working on them.",
      },
      emptyState: {
        headline: 'View all of your Exams',
        subheading:
          'Keep track of which Exams you’ve given to a Class and analyze the results.  You can create a new Exam on the Work page.',
      },
      columns: {
        name: 'Exam Name',
        publishedDate: 'Published Date',
        show: 'Show',
        show_helperText:
          'When turned on, the Exam is visible to your students in the Student App menu',
        autoAccept: 'Auto Accept',
        autoAccept_helperText:
          "Automatically accept students' requests to begin an Exam for a set amount of time",
        corrections: 'Corrections',
        corrections_helperText:
          'Require your students to fix and complete additional practice on all Exam errors while in Spiral Review',
      },
      confirmDeleteModal: {
        body: 'You are about to remove {{examName}}. If any students are working on this exam, they will be moved to other work. Are you sure you want to proceed?',
        cancel: 'Cancel',
        confirm: 'Remove',
        error: 'There was an error removing {{examName}}.',
        success: 'Removed {{examName}}.',
        title: 'Remove Exam',
      },
      examType_Initial: 'Exam',
      examType_FollowUp: 'Follow-up',
      examType_Corrections: 'Corrections',
      enabled: 'Enabled',
      errors: {
        show_false:
          'There was an error hiding {{examName}} from your class. Please try again.',
        show_true:
          'There was an error showing {{examName}} to your class. Please try again.',
      },
      autoAccept: {
        endsOn: 'Ends on {{dateTime}}',
        setExpiresAt: 'Set End Date & Time',
      },
      printModal: {
        error: 'There was an error printing the Exam. Please try again.',
        helperText: {
          type_Exact:
            'Prints your student’s actual exam with the exact problems they will see in the Student App.',
          type_Practice:
            'Prints a Practice Exam with problems similar to what your students will see on their actual Exam.',
        },
        notStatic:
          "You must print each student's exam from the student's exam view.",
        title: 'Print Options',
        type_Exact: 'Exact Exam',
        type_Practice: 'Practice Exam',
        includeAnswerKey: 'Include Answer Key',
      },
      saveGradeModal: {
        confirm: 'Create a new Follow-up',
        content:
          '<0>{{studentName}}</0> has already begun working on the Follow-up for this Exam. By saving grade changes to this Exam, their current follow-up progress will be discarded and a new Follow-up will be generated. Do you want to proceed?',
        title: 'Save Student Grade',
      },
      saveGradesModal: {
        confirm: 'Create new Follow-ups',
        content:
          'The following students have already begun working on their Follow-ups for this $t(common:exam). By saving grade changes to this $t(common:exam), their current Follow-up progress will be discarded and a new Follow-up will be generated. Do you want to proceed?',
        title: 'Save Student Grades',
      },
      stopExamModal: {
        body: 'Are you sure you want to pause the $t(common:exam)? If you continue, all students currently taking the exam will have their exam paused and Auto-Accept will be turned off.',
        confirm: 'Pause $t(common:exam)',
        title_Initial: 'Pause Exam: {{examName}}?',
        title_FollowUp: 'Pause Exam: {{examName}} - Follow-up?',
      },
      handedIn: {
        message:
          '<0>{{studentName}}</0> turned in {{examName}}: $t(exams:examType, { "context": "{{examType}}" }) for {{className}}',
        viewResults: 'View Results',
      },
      analysis: 'Analysis',
      switchLabels: {
        autoAccept:
          'Automatically accept requests for {{examName}}: $t(exams:examType, { "context": "{{examType}}" })',
        corrections: 'Turn corrections mode on for {{examName}}',
        show: 'Show {{examName}}: $t(exams:examType, { "context": "{{examType}}" })',
      },
      deleteExam: 'Delete {{examName}}',
    },
    expiredAccount: {
      extraBody:
        'P.S. Don’t worry! All of your work and data will be here waiting for you.',
      body_canBeExtended:
        'Complete the account set-up steps to get an extra <accent>30 days</accent>.',
      body_cannotBeExtended: 'Let’s get you back <accent>online</accent>.',
      button: 'Talk to us now',
      licenseExpired: 'Your license has expired.',
    },
    mixedReview: {
      classLevelStatistics: {
        accuracy: 'Accuracy',
        accuracyHelperText:
          'The average percentage of time students in your class answer correctly on their first attempt (Active Skills only)',
        activeSkills: 'Active $t(common:skill_plural)',
        day: 'Day',
        day_plural: 'Days',
        mixedReview: 'Spiral Review',
        noData: 'No Data',
        pointsDistribution: 'Points Distribution',
        pointsDistributionHelperText:
          'All points earned for this Class. Points earned should be weighted in favor of $t(common:mixedReview) (Active and inactive $t(common:skill_plural))',
        assignment: '$t(common:targeted_skill_plural)',
        rotationTime: 'Rotation Time',
        rotationTimeHelperText:
          'The median number of days it takes your students to correctly cycle through all Active $t(common:skill_plural) in Spiral Review',
      },
      deleteDialog: {
        title: 'Remove skill',
        content:
          'Removing $t(common:skill_plural) may alter some reported numbers.  Are you sure you want to remove this $t(common:skill) from $t(common:mixedReview)?',
      },
      enabled_true: 'Active',
      enabled_false: 'Inactive',
      expanded: {
        tabs: {
          accuracy: 'Accuracy',
          proficiency: 'Proficiency',
          problem: 'Problem',
        },
        proficiencyStats: {
          proficient: 'Proficient',
          notProficient: 'Not Proficient',
        },
      },
      tableRows: {
        enabled: 'Active',
        dateAdded: 'Date Added',
        description: 'Description',
      },
      emptyState: {
        headline: 'Retention Starts Here',
        subheading:
          "A collection of skills that automatically caters to each student's needs. Give your class an $t(common:assignment) to get started.",
        title: 'What is $t(common:mixedReview)?',
        alertMessage:
          '$t(common:student_plural) in this class do not have any skills to work on when they first log in.',
        buttonMessage: 'Add Starter $t(common:skill_plural)',
        listItemText1:
          '$t(common:mixedReview) is dynamically generated and individualized for each student, and it builds automatically as the year progresses.',
        listItemText2:
          'The purpose of $t(common:mixedReview) is to provide long-term retention and cumulative individualized practice to break the forgetting cycle.',
        listItemText3:
          'It prioritizes skills that a student needs to practice, both new and mastered.',
        listItemText4:
          '$t(common:skill_plural) from $t(common:assignment_plural) are automatically added to $t(common:mixedReview). Click on the Work tab to manage your $t(common:assignment_plural).',
      },
      table: {
        actions: {
          activate: 'Activate',
          disabledActivate: 'There are no inactive skills selected',
          deactivate: 'Deactivate',
          disabledDeactivateActive: 'One skill must be active at all times',
          disabledDeactivate: 'There are no active skills selected',
        },
        batchActions: {
          activate: 'Activate',
          activate_disabled: 'There are no inactive skills selected',
          createExamTemplate: 'Create Exam',
          createExamTemplate_disabled: 'There are no skills selected',
          createAssignment: 'Create $t(common:assignment)',
          createAssignment_disabled: 'There are no skills selected',
          deactivate: 'Deactivate',
          deactivate_disabled: 'There are no active skills selected',
          deactivate_disabledActive: 'One skill must be active at all times',
          title: 'Actions',
        },
        columns: {
          enabled: 'Active',
          dateAdded: 'Date Added',
          description: 'Description',
          accuracy: 'Accuracy',
          accuracy_helperText:
            'Percentage of time students answer correctly on their first attempt',
          notEnoughData: 'Not Enough Data',
          notEnoughData_helperText: 'Not enough data to calculate proficiency',
          unattempted: 'Untried',
          unattempted_helperText:
            'Students who have not practiced a $t(common:skill). Included in the count of students who have "red" on a $t(common:skill).',
          red: 'Red',
          red_helperText:
            'Students who have "red" on a $t(common:skill). Includes students who have never practiced a $t(common:skill).',
          yellow: 'Yellow',
          yellow_helperText: 'Students who have "yellow" on a $t(common:skill)',
          green: 'Green',
          green_helperText: 'Students who have "green" on a $t(common:skill)',
          silver: 'Silver',
          silver_helperText: 'Students who have "silver" on a $t(common:skill)',
          gold: 'Gold',
          gold_helperText: 'Students who have "gold" on a $t(common:skill)',
          proficiency: 'Proficient Students',
          proficiency_helperText:
            'Percentage of students who have achieved "green," "silver," or "gold" on a $t(common:skill)',
        },
        disabledRemove: 'You must keep one active skill',
        disablingError:
          'One or more $t(common:student_plural) have this $t(common:skill) as their only $t(common:skill) in their $t(common:modifiedMixedReview)',
        disablingError_plural:
          'One or more $t(common:student_plural) have these $t(common:skill_plural) as their only $t(common:skill_plural) in their $t(common:modifiedMixedReview)',
        labels: {
          enabled_true: 'Deactivate {{skillName}}',
          enabled_false: 'Activate {{skillName}}',
        },
        title: 'All $t(common:skill_plural)',
        title_selected: '{{count}} $t(common:skill) selected',
        title_selected_plural: '{{count}} $t(common:skill_plural) selected',
      },
      removeSkill: 'Remove {{description}} from Spiral Review',
      skillCode: 'Skill Code',
    },
    pointsHistory: {
      classTotals: 'Class Totals',
      dailyGoals: 'Daily Goal',
      dateRange: { end: 'End', start: 'Start', to: 'to' },
      dateRangeValidation: {
        tooLong:
          'You can select a maximum of {{count}} $t(common:day, { "count": {{count}} }) for the Points History Report.',
        fetchError:
          'Something went wrong with your date selection on the Points History Report. Please, try another date range.',
      },
      dataType: {
        assignmentsAndMixedReview_label:
          'Points Earned from <0>Targeted Skills</0> & <1>$t(common:mixedReview)</1>',
        assignmentsAndMixedReview_description:
          'Shows the totals for all $ problems correct on first attempt from Targeted Skills compared to from $t(common:mixedReview).',
        pointsEarned_label: '<0>Total Points Earned</0>',
        pointsEarned_description:
          'Shows the totals for all $ problems correct on first attempt.',
        totalAndErrorsFixed_label:
          '<0>Total Points Earned</0> & <1>Errors Fixed</1>',
        totalAndErrorsFixed_description:
          'Shows the totals for all $ problems correct on first attempt and a count of $ mistakes that have been fixed.',
      },
      goalForTheDay: 'Goal for the day',
      studentName: 'Name',
      table: { name: 'Points History' },
      totals: 'Totals',
      emptyState: {
        headline: 'How did everyone do yesterday?',
        subheading:
          'Get a quick look at past daily goals to see how much progress your students are making.',
        dateRange: 'We could not find any data in this date range.',
      },
      fetchPointsError: 'An error occured while getting data for this student.',
    },
    problemPreview: {
      addSkill: 'Add Skill',
      addProblem: 'Add Problem',
      addSkillDisabled_Assignment:
        'This skill has already been added to the assignment.',
      addSkillDisabled_Exam: 'This skill has already been added to the exam.',
      addProblemDisabled_Exam:
        'This problem has already been added to the exam.',
      addSkillWillCreate_Assignment:
        'Create a new assignment and add this skill.',
      addSkillWillCreate_RandomExam: 'Create a new exam and add this skill.',
      addProblemWillCreate_LockedExam:
        'Create a new exam and add this problem.',
      answerTab: 'Answer',
      buttons: { close: 'Close Preview', refresh: 'Refresh Preview' },
      fetchingProblem: {
        active: 'Loading Problem Preview',
        error: 'Error Loading Problem',
        errorAnswer: 'Error Loading Answer',
      },
      problemTab: { current: 'Problem', sample: 'Sample' },
      studentsTab: 'Students',
      studentsTable: { columns: { name: 'Name' } },
    },
    reports: {
      averageStandard: 'Average Standard',
      emptyState: {
        class: {
          noClassesAlert:
            'This $t(common:teacher) does not currently have any $t(common:class_plural).',
          noStudentsAlert:
            'This $t(common:class) does not currently have any $t(common:student_plural).',
          bullet1:
            'Get a high level look at how your $t(common:student_plural) are doing on a particular $t(common:subject).',
          bullet2:
            'Easily identify which $t(common:student_plural) need the most help.',
          bullet3:
            'Group your $t(common:student_plural) by the standards that they need to work on the most.',
          title: '$t(common:class) Report',
        },
        student: {
          noClassesAlert:
            'This $t(common:teacher) does not currently have any $t(common:class_plural).',
          noData: 'No $t(common:skill_plural) have been attempted yet.',
          noStudentsAlert:
            'This $t(common:class) does not currently have any $t(common:student_plural).',
          bullet1:
            'Get a detailed look at how a $t(common:student) is doing on a particular $t(common:subject).',
          bullet2:
            'Easily identify the areas where a $t(common:student) needs the most help.',
          bullet3:
            'Drill down to the exact skills the $t(common:student) should be focusing on.',
          title: '$t(common:student) Report',
        },
        usage: {
          headline: "There's not enough data to show a report yet.",
          subHeading:
            'Please make sure there is at least one active teacher and one active student.',
          disabled: {
            headline:
              'Usage Reports are temporarily unavailable due to scheduled maintenance.',
            subHeading:
              'If you need further assistance or have any questions, please email support@getmoremath.com.',
          },
        },
      },
      dropdowns: {
        class: '$t(common:class)',
        report: 'Type',
        school: 'School',
        student: '$t(common:student)',
        teacher: '$t(common:teacher)',
        organization: 'Organization',
        campus: 'Campus',
      },
      key: 'Key',
      keyCircle_Green: 'Proficient',
      keyCircle_Grey: 'No Data',
      keyCircle_Red: 'Not Proficient',
      keyCircle_Yellow: 'Partially Proficient',
      keyCircle_Blue: 'Outstanding',
      keyCircle_Orange: 'Acceptable',
      keyCircle_LightGrey: 'Needs Improvement',
      overall: 'Overall',
      allStandards: 'All Standards',
      proficiencyHighsAndLows: 'Proficiency Highs and Lows',
      proficiencyLevels: {
        proficient: 'Proficient',
        notProficient: 'Not Proficient',
        partiallyProficient: 'Partially Proficient',
      },
      proficientStandards: 'Proficient Standards',
      skillsTableColumns: {
        accuracy: 'Accuracy',
        attempts: 'Attempts',
        color: 'Color',
        id: '$t(common:skill) Code',
        lastCorrect: 'Last Correct',
        lastFive: 'Last Five',
        name: 'Description',
      },
      standard: 'Standard',
      standard_plural: 'Standards',
      totalStandards: 'Total Standards',
      reportTypes: {
        class: '$t(common:class) Report',
        student: '$t(common:student) Report',
        usage: 'Usage Report',
      },
      usageTableColumns: {
        orgName: 'School',
        teacherName: 'Teacher',
        className: '$t(common:class)',
        studentName: 'Student Name',
        activeSkills: 'Active Skills',
        activeSkills_helperText: 'Number of skills currently in Spiral Review.',
        activeStudents: 'Enrolled Students',
        activeStudents_helperText:
          'The number of students that have attempted at least one problem.',
        activeStudentsLast30Days: 'Students Last 30 Days',
        activeStudentsLast30Days_helperText:
          'The number of students that have attempted at least one problem in the last 30 days.',
        activeTeachers: 'Teachers This Year',
        activeTeachersLast30Days: 'Teachers Last 30 Days',
        avgCompletedProblems: 'Problems Per Student',
        avgCompletedProblems_helperText:
          'Average of problems completed per student.',
        completedProblems: 'Problems Completed',
        completedProblemsLast30Days: 'Problems Last 30 Days',
        pointsEarned: 'Points Earned ($)',
        pointsEarned_helperText:
          'Sum of targeted skills ($) answered correctly on first try for all students.',
        pointsEarned_studentHelperText:
          'Targeted skills ($) answered correctly on the first try.',
        skillAccuracy: 'Skill Accuracy',
        skillAccuracy_helperText:
          "Average of student accuracy values, which are based on the average of the accuracy of each skill (active or inactive) the student has ever attempted. A single skill's accuracy is the number correct on first try divided by the total number of first tries. <br/> <br/> 0% to 69% Gray; 70% to 75% Orange; 76% to 100% Blue",
        skillAccuracy_studentHelperText:
          "Average of the accuracy of each skill (active or inactive) the student has ever attempted in a class. A single skill's accuracy is the number correct on first try divided by the total number of first tries. <br/> <br/> 0% to 69% Gray; 70% to 75% Orange; 76% to 100% Blue",
        activeProficientSkills: 'Active Proficient Skills (Green+)',
        percentOfActiveSkillsProficient: 'Percent of Active Skills Proficient',
        percentOfActiveSkillsProficient_helperText:
          "Average of all students' individual proficiency scores.  A student's proficiency score is calculated by the ratio of proficient skills to all active skills in Spiral Review. Proficient skills are green, silver, or gold on the student screen. <br/> <br/> 0% to 39% Gray; 40% to 59% Orange; 60% to 100% Blue",
        percentOfActiveSkillsProficient_studentHelperText:
          'Ratio of the number of proficient skills to all skills using only active skills in Spiral Review. Proficient skills are green, silver or gold on the student screen. <br/> <br/> 0% to 39% Gray; 40% to 59% Orange; 60% to 100% Blue',
        activeProficientSkills_rawHelperText:
          'The number of proficient skills in Spiral Review.',
        pointsFromSpiralReview: 'Points from Spiral Review',
        pointsFromSpiralReview_helperText:
          'Average of student points from Spiral Review. Note: Points are earned for targeted skills ($) only. <br/> <br/> 0% to 39% Gray; 40% to 59% Orange; 60% to 100% Blue',
        pointsFromSpiralReview_studentHelperText:
          'Ratio of the points earned in Spiral Review to total points earned in both Spiral Review and Assignments for one class. Note: Points are earned for targeted skills ($) only. <br/> <br/> 0% to 39% Gray; 40% to 59% Orange; 60% to 100% Blue',
        rotationTime: 'Rotation Time',
        rotationTime_helperText:
          'Median of all student rotation times. Student rotation time: number of days to cycle through all active skills in Spiral Review. <br/> <br/> 0-30 days Blue; 31-44 days Orange; 45 or more days Gray',
        rotationTime_studentHelperText:
          'Number of days to cycle through all active skills in Spiral Review. <br/> <br/> 0-30 days Blue; 31-44 days Orange; 45 or more days Gray',
        yellow: 'In Progress (Yellow)',
        yellow_helperText:
          'The number of skills in Spiral Review that have shown early (short-term) success and are moving toward proficient, but need more practice',
        red: 'Not Proficient (Red)',
        red_helperText:
          'The number of skills in Spiral Review at a beginning level. These need more practice and possibly teacher assistance.',
        untried: 'Untried',
        untried_helperText:
          'The number of skills in Spiral Review that this student has never attempted.',
      },
      overview: {
        schools: 'Schools',
        teachers: 'Teachers',
        students: 'Students',
        problems: 'Problems',
        thisYear: 'This Year',
        last30Days: 'Last 30 Days',
        title: 'Overview',
      },
      studentTable: 'Students',
      classTable: 'Classes',
      teacherTable: 'Teachers',
      orgTable: 'Schools',
      district: 'District',
      ariaNavMenu: 'Navigation Menu',
    },
    roster: {
      'add-students': 'Add Students',
      classCode:
        'New and existing students can also join this class by using the class code.',
      create: {
        button: 'Create Student',
        disabledTooltip: 'You must own the class to create new students',
        title: '$t(roster:add-students) – Create',
        headline: 'Create new student accounts',
        subheading: 'Create new student accounts and add them to this class.',
      },
      emptyState: {
        headline: 'Add students to your class to get started.',
        subHeading:
          'Once students have been added to your class with your roster management system, they will get synchronized and show up here.',
        subHeading_google:
          'Once students have been added to your class with your roster management system, they will show up here. This process may take a few moments after importing or syncing your class.',
      },
      emptyStateWithClassLink: {
        addManually: 'Add students manually',
        bodyOne: 'Students can use this link to join your class.',
        bodyTwo: 'Try the link yourself.',
        headline: 'Provide a Class Enrollment Link for your students',
      },
      errors: {
        alphanumeric: 'Alphanumeric characters only',
        invalidName: 'Alphanumeric characters, spaces, and dashes only',
        schoolAssignedId: { matches: 'Alphanumeric characters only' },
      },
      learnHow: 'Learn How',
      printClass: {
        tooltip_canDoActions_true: 'There are no students in this class.',
        tooltip_canDoActions_false:
          'This class is managed by {{idp}} and we are unable to print student-specific information.',
        buttons: { print: 'Print' },
        description:
          'Print usernames and passwords for all the students in your Class. If your students know their current password, they may continue to use it.',
        errors: {
          studentList:
            "We're having trouble getting your list of students. Please try again later.",
          printing:
            'There was an error printing your class roster. Please try again.',
        },
        form: {
          labels: {
            differentPassword: 'Get a unique password for each student',
            samePassword: 'Get the same password for the whole class',
          },
        },
        preview: {
          header: 'User Credentials for {{className}}',
          table: {
            alternate: 'Alternate (see note)',
            password: 'Password',
            student: 'Student',
            username: 'Username',
          },
        },
        privacy: {
          note: 'Note: Due to privacy laws, we do not display passwords created by students. However, the alternate works in its place.',
        },
        title: 'Print Class Roster',
      },
      search: {
        button: 'Search for Student',
        disabledTooltip: 'Import students disabled',
        input: {
          base: 'Search',
          level_None: '$t(roster:search.input.base) None',
          level_District: '$t(roster:search.input.base) District',
          level_Region: '$t(roster:search.input.base) Region',
          level_School: '$t(roster:search.input.base) School',
        },
        noResults: {
          headline: 'No students found',
          subheading:
            'There were no results for "{{query}}".  Please check the student\'s name and try again.',
        },
        table: {
          add: 'Add',
          lastLogin: 'Last Login',
          lastSchool: 'Last School',
          lastTeacher: 'Last Teacher',
          never: 'Never',
          schoolAssignedId: 'School Assigned ID',
          timeAgo: '{{timeAgo}} ago',
          username: 'Username',
        },
        title: '$t(roster:add-students) – Search',
        toasty: 'Students that you add to the class will show up here.',
        headline: 'Search for existing students',
        headline_searchDisabled: 'Import students disabled',
        subheading:
          'Search for students who have used GMM in the past and add them to this class.',
        subheading_searchDisabled:
          'Your district his disabled this feature.  Please contact your administrator for more information.',
      },
      table: {
        action: {
          addStudents_tooltip: 'Add Students',
          addStudents_noPermission:
            'This class is managed by {{idp}} and you may add students from there.',
          classCode: 'Class Code',
          classCode_tooltip:
            'Students can use this code to join your class from the student login page.',
          print_tooltip: 'Print Class Roster',
        },
        header: { name: 'Name', username: 'Username' },
        undo: 'Undo',
      },
      toolbar: {
        addStudents: '$t(roster:add-students)',
        roster: 'Roster',
        studentPlural: 'students',
        studentSingular: 'student',
        sync: 'Sync with {{provider}}',
        syncError: 'There was a problem syncing with {{provider}}.',
        syncErrorNoClass:
          'We were unable to locate this class in {{provider}}. Please Check your {{provider}} account.',
        syncSuccess: 'We have begun to sync your {{provider}} roster into GMM',
        viewClassLink: 'View Class Enrollment Link',
      },
      unsavedChanges: {
        title: 'Cancel Student Creation',
        message: 'This will cancel the creation of new student accounts.',
      },
    },
    rosterClasses: {
      actions: {
        confirm: 'Import Classes',
        dismiss: 'Cancel',
        acknowledge: 'Ok',
      },
      emptyState:
        'No active classes found. Please try again once an active class has been added in {{context}}.',
      rosteredDate: 'Rostered: {{rosteredDate}}',
      subtitle: 'Selected Classes will be rostered',
      title: 'Import Classes from {{provider}}',
      complete: {
        headline: 'Thank you for importing your classes!',
        subheading:
          'We will continue to roster your students in the background.',
      },
      validationMessage: { subject: 'Subject is required' },
      importSync: 'We have begun to import your {{provider}} roster into GMM',
      auth: {
        title: 'There was an issue accessing your {{provider}} info',
        message: 'Please re-login to Get More Math and try again.',
      },
      snackbar: {
        added:
          '{{addedLength}} student(s) added in $t(rosterClasses:snackbar.successfulMessage)',
        removed:
          '{{removedLength}} student(s) removed in $t(rosterClasses:snackbar.successfulMessage)',
        bothAddedAndRemoved:
          '{{addedLength}} added and {{removedLength}} removed in $t(rosterClasses:snackbar.successfulMessage)',
        successfulMessage: 'successful {{type}} with {{provider}} for {{name}}',
        noChange:
          'No Changes were detected in {{type}} with {{provider}} for {{name}}',
        failureMessage:
          '{{failedLength}} students were not rostered during a failed {{type}} attempt with {{provider}} for {{name}}',
        singularFailureMessage:
          '{{failedLength}} student was not rostered during a failed {{type}} attempt with {{provider}} for {{name}}',
      },
      viewResults: 'View',
      rosteredResults: {
        title: '{{status}} {{type}} of {{name}}',
        ok: 'OKAY',
        addedSummary: '{{rosteredMetricLength}} Students Added',
        removedSummary: '{{rosteredMetricLength}} Students Removed',
        accordionViewResults: 'VIEW',
        accordionHideResults: 'HIDE',
      },
    },
    selectedExam: {
      columns: {
        name: 'Name',
        status: 'Status',
        score: 'Score',
        score_Initial: 'Exam Score',
        score_FollowUp: 'Follow-Up Score',
        grade_Initial: 'Exam Grade',
        grade_FollowUp: 'Follow-Up Grade',
        initialScore: 'Exam Score',
        initialGrade: 'Exam Grade',
        followUpScore: 'Follow-Up Score',
        followUpGrade: 'Follow-Up Grade',
      },
      emptyState: {
        headline: 'Student results will show here',
        subHeading:
          'See how students performed on the Exam. Add students to your Class to get started.',
      },
      gradeTurnedIn: {
        button: 'Grade Turned In $t(common:exam_plural)',
        errorMessage:
          'There was an error saving $t(common:exam) grades. Please try again.',
        tooltip: 'There are no Turned In Exams ready to be graded.',
      },
      status_Unknown: 'Unknown',
      status_NotStarted: 'Not Started',
      status_InProgress: 'In Progress',
      status_Paused: 'Paused',
      status_TurnedIn: 'Turned In',
      status_Graded: 'Graded',
      status_NotGenerated: 'Not Generated',
      stopExam: {
        button: 'Pause $t(common:exam)',
        tooltip: 'There are no $t(common:exam_plural) to pause.',
        success:
          '{{examName}} has been paused for all students currently taking the exam in {{className}}, and Auto-Accept has been turned off.',
      },
      viewAnalysis: {
        button: 'View Analysis',
        tooltip: "You must grade your students' exams first",
      },
      title: 'Scores',
      exportColumns: {
        score_FollowUp: 'Follow-Up Score,Follow-Up Total',
        score_Initial: 'Exam Score,Exam Total',
      },
    },
    signUp: {
      emailTaken:
        'Email already in use. <login>Login</login> or <resetPassword>Reset Password</resetPassword>?',
      fields: {
        email: 'School Email Address',
        firstName: 'First Name',
        lastName: 'Last Name',
        password: 'Password',
        utmCampaign: 'Referral Code (optional)',
      },
      logIn: { student: 'Student Log In', teacher: 'Teacher Log In' },
      logo: 'Logo',
      possibleStudentEmail:
        'If you are a student, you can login <studentLink>here</studentLink>.',
      submit: 'Create Account',
      termsAndPrivacy:
        'By creating an account, you agree to our <terms>Terms</terms> and <privacy>Privacy Policy</privacy>.',
      title: 'New Teacher Sign Up',
      description:
        'Sign up for new teacher accounts for pilots and existing customers. Create a new teacher account for Get More Math here.',
    },
    skillDiscovery: {
      collapseAll: 'Collapse All',
      results: '{{count}} Result',
      results_plural: '{{count}} Results',
      newSkills: 'New!',
      search: 'Search Skills',
      colleagues: {
        button: 'Colleagues and My Work',
        district: 'My District',
        school: 'My School',
        work: 'My Work',
      },
      emptyFolderMessage: 'This folder is empty',
      breadcrumbs: '{{grade}} {{collection}} Breadcrumbs',
      skillBank: '{{grade}} {{collection}} Skill Bank',
    },
    studentData: {
      emptyState: {
        headline: 'View your students’ progress',
        subHeading:
          'Compare students against their peers to see who needs help',
        tabs: {
          assignments: {
            headline:
              'View all your students and their $t(common:assignment_plural)',
            subHeading:
              'See all students at a glance and how each individual student is doing on their $t(common:assignment_plural)',
          },
          exams: {
            headline: 'View all your students and their $t(common:exam_plural)',
            subHeading:
              'See all students at a glance and how each individual student is doing on their $t(common:exam_plural)',
          },
          mixedReview: {
            headline: 'View all your students and their skills',
            subHeading:
              'See all students at a glance and drill down to individual students to see who needs help',
          },
        },
      },
      columns: {
        accuracy: 'Skill Accuracy',
        accuracy_helperText:
          'Average accuracy of a student’s $t(common:skill_plural) (Active and inactive $t(common:skill_plural))',
        assignedOn: 'Date Assigned',
        assignmentName: '$t(common:assignment) Name',
        assignmentErrorsFixed: 'Errors Fixed',
        attempts: 'Total $ Attempts',
        attempts_helperText:
          'Total number of $ problems attempted (Active, inactive, and removed $t(common:skill_plural))',
        averageFollowUpScore: 'Average Follow-Up Score',
        averageScore: 'Average Score',
        completed: 'Completed',
        errorsFixed: 'Errors Fixed',
        examName: 'Exam Name',
        examScore: 'Exam Score',
        examStatus: 'Exam Status',
        followUpScore: 'Follow-Up Score',
        followUpStatus: 'Follow-Up Status',
        graded: 'Graded',
        errorsFixed_helperText:
          'Total number of mistakes that have been fixed (Active, inactive, and removed $t(common:skill_plural))',
        mixedReview: 'Points from SR',
        mixedReview_helperText:
          'Percentage of points earned in $t(common:mixedReview) (Active, inactive, and removed $t(common:skill_plural))',
        notStarted: 'Not Started',
        pointsEarned: 'Points Earned',
        pointsEarned_helperText:
          'Number of $ problems answered correctly on the first attempt (Active, inactive, and removed $t(common:skill_plural))',
        pointsEarnedOfRequired: '{{pointsEarned}} of {{pointsRequired}}',
        proficiency: 'Proficient Skills',
        proficiency_helperText:
          'Percentage of Skills on which the student has achieved "green", "silver", or "gold" (Active and inactive $t(common:skill_plural))',
        publishedDate: 'Published Date',
        studentName: 'Student Name',
      },
      exportColumns: {
        completed: 'Completed,Total',
        graded: 'Graded,Total',
        pointsEarned: 'Points Earned,Required',
      },
      tabs: {
        assignments: 'Assignments',
        exams: 'Exams',
        mixedReview: 'Spiral Review',
      },
      cycle: {
        next: 'View next $t(common:student)',
        previous: 'View previous $t(common:student)',
      },
    },
    studentDetail: {
      currentProblem: {
        error: { overriding: 'Error replacing current problem' },
        label: 'Current Problem',
        overriding: 'Replacing current problem. This usually takes ~7 seconds.',
      },
      helpRequestedProblem: {
        blankState:
          'When a student requests help, their problem will show up here.',
        blankState_takingExam:
          'Students cannot request help while they are working on an Exam.',
        error: { overriding: 'Error replacing help-requested problem' },
        label: 'Requesting Help With',
        overriding:
          'Replacing help-requested problem. This usually takes ~7 seconds.',
      },
      overrideProblemButton: 'Replace Problem',
      overrideProblemButtonTooltip_takingExam:
        'You cannot replace an Exam problem',
      overrideProblemButtonTooltip_offline:
        'Student is not logged in to this class',
      sendGameCreditButton: 'Give game credit',
      sendMessageButton: 'Send',
      sendMessageLabel: 'Send Message',
      success: {
        problemOverridden: 'Problem replaced',
        sendGameCredit: 'Game Credit Sent',
        sendMessage: 'Message Sent',
      },
      error: {
        sendGameCredit: 'Unable to send game credit',
        sendMessage: 'Unable to send message',
        currentProblem: "Unable to get student's current problem",
      },
    },
    studentExam: {
      emptyStateContent:
        'A Follow-up Exam has not been created yet. Once you have saved the student’s Exam grade, a Follow-up will be automatically created.',
      errorSaving:
        'There was an error saving the $t(common:exam) grade. Please try again.',
      examHeader: '{{examType}} - <0>{{studentName}}</0>',
      grading_Full: '(F)ull Credit',
      grading_Partial: '(P)artial Credit',
      grading_None: '(N)o Credit',
      confirmGrade: 'Save Grade',
      confirmGradeAndNavigate: 'Save grade and move to next student',
      status_Correct: 'Correct',
      status_FullCredit: 'Full Credit Given',
      status_Incorrect: 'Incorrect',
      status_PartialCredit: 'Partial Credit Given',
      status_Unseen: 'Never Viewed',
      status_ViewedNotAnswered: 'Viewed, Not Answered',
      turnIn: 'Turn In',
      turnIn_failure:
        "There was an error turning in <0>{{studentName}}</0>'s $t(common.exam).  Please try again.",
      turnInModal: {
        content:
          'Your student may still be working on this $t(common:exam). If you proceed, your student will be notified, kicked out of the $t(common:exam), and moved back to practice. Do you want to continue?',
        title: '$t(studentExam:turnIn) $t(common:exam)',
      },
      unsavedChanges: {
        message: 'This will cancel the grading of this exam.',
        title: 'Cancel Grading Exam',
      },
      viewNext: 'View next student’s $t(common:exam)',
      viewPrevious: 'View previous student’s $t(common:exam)',
    },
    studentInfo: {
      activeClasses: 'Active Classes',
      deleteModal: {
        title: 'Confirm Removal',
        text: 'Are you sure you want to remove this student from {{className}}?',
        rosterText:
          'Are you sure you want to remove this student from the class?',
        cancelButton: 'Cancel',
        success: 'Successfully removed the student from class',
      },
      firstName: 'First Name',
      lastName: 'Last Name',
      schoolAssignedId: 'Student Id',
      username: 'Username',
      passwordModal: {
        alternate: 'Alternate Password',
        alternateNote:
          'You still  have the option to reset the student’s password',
        studentPassword: '<0>{{studentName}}</0>’s Current Password',
      },
      resetPassword: 'Reset Password',
      resetModal: {
        title: 'Student Password',
        success: 'Successfully reset password',
        errors: { password: 'Password is required' },
      },
      usernameAlreadyExists: 'Username already exists, please try another.',
      unsavedChanges: {
        title: 'Cancel Settings Changes',
        message:
          "This will cancel the changes you have made to your student's settings.",
        negative: "Don't Cancel",
        affirmative: 'Cancel',
      },
      update: 'Updated student successfully',
      errors: {
        firstName: 'First Name is required',
        lastName: 'Last Name is required',
        username: 'Username is required',
        invalidStudentId: 'Alphanumeric characters only',
      },
      ssoAlert:
        "The student's {{data}} is managed by {{idp}} and cannot be changed here.",
    },
    studentReport: {
      days: 'Day',
      days_plural: 'Days',
      colors: {
        untried: 'Untried',
        'not enough data': 'Not Enough Data',
        red: 'Red',
        yellow: 'Yellow',
        green: 'Green',
        silver: 'Silver',
        gold: 'Gold',
      },
      stats: {
        pointsDistribution: 'Points Distribution',
        pointsDistribution_helperText:
          'All points earned for this Class.  Points earned should be weighted in favor of Spiral Review.',
        pointsDistributionEmpty: 'No Data',
        accuracy: 'Skill Accuracy',
        accuracy_helperText: 'Average accuracy of all Skills in this Class',
        pointsEarned: 'Points Earned',
        pointsEarned_helperText:
          'Number of $ problems answered correctly on the first attempt',
        attempts: 'Total $ Attempts',
        attempts_helperText: 'Total number of $ problems attempted',
        errorsFixed: 'Errors Fixed',
        errorsFixed_helperText: 'Total number of mistakes that have been fixed',
        rotationTime: 'Rotation Time',
        rotationTime_helperText:
          'The number of days it takes to correctly cycle through all Active Skills in Spiral Review',
        activeSkillsAccuracy: 'Skill Accuracy',
        activeSkillsAccuracy_helperText: 'Average accuracy of Active Skills',
        unfixedErrors: 'Unfixed Errors',
        unfixedErrors_helperText:
          'The number of Active Skills currently marked wrong',
        currentPenalties: 'Penalties',
        currentPenalties_helperText: 'The number of penalties on Active Skills',
        skillColor: '{{color}}',
      },
      summary: {
        title: 'All Time',
        legend: {
          mixedReview: 'Spiral Review',
          assignments: '$t(common:targeted_skill_plural)',
        },
      },
      activeSkills: { title: 'Active Skills' },
      allSkills: {
        title: 'All Skills',
        mixedReviewToggles: {
          class: 'Use Class Spiral Review',
          individual: '$t(common:modifiedMixedReview)',
        },
        columns: {
          active: 'Active',
          class: 'Class',
          dateAdded: 'Date Added',
          description: 'Description',
          color: 'Color',
          accuracy: 'Accuracy',
          accuracy_helperText:
            'Percentage of time this Skill is answered correctly on the first attempt',
          attempts: 'Attempts',
          attempts_helperText: 'The number of problems attempted',
          lastFive: 'Last 5',
          lastFive_helperText: 'Accuracy on the most recent five problems',
          lastCorrect: 'Last Correct',
          lastCorrect_helperText:
            'The most recent date the student answered correctly on their first attempt',
          currentPenalties: 'Penalties',
          currentPenalties_helperText:
            'The current penalty count for each Skill',
          currentlyWrong: 'Unfixed Error',
          currentlyWrong_helperText: 'Currently marked wrong',
        },
        emptyState: {
          headline: 'Student-Specific Skills Breakdown',
          subHeading:
            'View the progress for all Skills this student has worked on in this Class',
        },
      },
      skillCode: 'Skill Code',
    },
    studentSettings: {
      removeFromClass: 'Remove from Class',
      title: "{{studentName}}</0>'s Settings",
      form: {
        success: 'Settings Updated',
        actions: { override: 'Individualize', useClass: 'Use Class Setting' },
        labels: {
          allowStudentMessaging: 'Allow student messaging',
          disableGames: 'Disable games',
          disablePenalties: 'Disable Penalties',
          readAloud: "Allow 'read aloud'",
          multipleChoiceLimit: 'Limit multiple choice to three',
          classSettings:
            "You can customize this setting for this student by clicking 'override' instead of using the class's current setting.",
          customSettings: 'This is currently using custom settings.',
        },
      },
      resetPassword: 'Reset Password',
      seePassword: 'See Password',
    },
    subjects: {
      AlgebraOne: 'Algebra I',
      AlgebraTwo: 'Algebra II',
      fields: {
        targetStandards: 'Target Standards',
        subject: '$t(common:subject)',
        subjectName: '$t(common:subject) Name',
      },
      Geometry: 'Geometry',
      Grade3: 'Grade 3',
      Grade4: 'Grade 4',
      Grade5: 'Grade 5',
      Grade6: 'Grade 6',
      Grade7: 'Grade 7',
      Grade8: 'Grade 8',
      MathOne: 'Math I',
      MathTwo: 'Math II',
      MathThree: 'Math III',
      noSubject: 'No $t(common:subject) Specified',
      Other: 'Other',
      Stats: 'Statistics',
      Trig: 'Trigonometry',
    },
    table: {
      columnMenu: {
        addOrRemoveColumns: 'Add or remove columns',
        columnVisibility: 'Manage Columns',
      },
      labels: {
        displayName: 'Name',
        selectAll: 'Select All',
        selectRow: 'Select row {{rowIndex}}',
      },
    },
    trainerSettings: {
      stateSelector: 'State Selector',
      title: 'Trainer Settings',
    },
    validation: {
      label: {
        capitalized: '{{path, capitalize}}',
        newStudents: {
          firstName: 'First Name',
          lastName: 'Last Name',
          schoolAssignedId: 'Student ID',
        },
      },
      array: { unique: 'Duplicate {{path}}' },
      mixed: {
        default: '{{path}} is invalid',
        defined: '{{path}} is required',
        required: '{{path}} is required',
        oneOf: '{{path}} must be one of the following values: {{values}}',
        oneOf_match: '{{path}} does not match {{matchPath}}',
        notOneOf:
          '{{path}} must not be one of the following values: {{values}}',
        notOneOf_match: '{{path}} should not match {{matchPath}}',
      },
      string: {
        email: '{{path}} must be a valid email',
        matches: '{{path}} must match the following: "${regex}"',
        max: '{{path}} must be at most {{max}} characters',
        min: '{{path}} must be at least {{min}} characters',
      },
      number: {
        max: '{{path}} must be less than or equal to {{max}}',
        min: '{{path}} must be greater than or equal to {{min}}',
      },
      fromApi: {
        alreadyTaken: '{{path}} must be unique.',
        invalidPattern: "{{path}} doesn't look right.",
        invalidType: "{{path}} doesn't look right.",
        required: '{{path}} is required.',
        tooLong: '{{path}} must be at most {{value}} characters.',
        tooShort: '{{path}} must be at least {{value}} characters.',
        unprocessable: 'The request was unprocessable.',
      },
    },
    welcome: {
      headline: 'How Get More Math Works',
      buttonGetStarted: 'Get Started',
      buttonToApp: "Let's Go",
      sendCode: 'Send Code',
      skipForNow: '<button>Skip for now</button>',
      slide: {
        FindSchool: {
          subHeading: 'Select your school to work with your colleagues',
          tagline: 'Share work and add co-teachers',
        },
        SelectState: {
          international: 'I’m not in the U.S.',
          subHeading:
            'Math $t(common:skill_plural) aligned with your state standards.',
          tagline:
            'We currently support all 50 states. Select your state below.',
        },
        SendEmail: {
          subHeading: 'Confirm your email address',
          tagline: 'We will send a verification code to your email',
        },
        VerifyEmail: { subHeading: 'Confirm your email address', tagline: '' },
        BreakForgettingCycle: { subHeading: '', tagline: '' },
      },
      welcome: 'Welcome to',
    },
    work: {
      create: {
        add: 'Add work menu',
        folder: { label: 'Folder Name', title: 'Create Folder' },
        assignment: 'Create $t(common:assignment)',
        examTemplate: 'Create Exam',
      },
      edit: { folder: { label: 'Folder Name', title: 'Rename Folder' } },
      emptyState: {
        clickHereToStart: 'Click here to start',
        headline: '$t(common:assignment_plural) and Folders',
        subheading:
          'Organize all of your work and build $t(common:assignment_plural) here on the left. Explore, preview, and add Skills on the right.',
        headline_examTemplate:
          '$t(common:assignment_plural), Exams, and Folders',
        subheading_examTemplate:
          'Organize all of your work and build $t(common:assignment_plural) and Exams here on the left. Explore, preview, and add Skills on the right.',
      },
      folderForm: {
        errors: {
          duplicate: 'A folder with that name already exists.',
          maxLength:
            'A folder name must be less than {{max}} characters in length.',
          required: 'A folder name is required.',
        },
      },
      menu: {
        buttons: {
          collapseWork: 'Collapse work navigator',
          collapseSkills: 'Collapse skill navigator',
          expandSkills: 'Expand skill navigator',
          expandWork: 'Expand work navigator',
        },
        skillsTitle: 'Skills',
        workTitle: 'My Work',
      },
      more: { rename: 'Rename', remove: 'Remove' },
      navigator: {
        error: 'There was an error moving your {{type}}.  Please try again.',
      },
      errors: {
        create: 'There was an error creating your {{type}}.',
        edit: 'There was an error saving your {{type}}.',
        copy: 'There was an error copying {{itemName}} to your Work.',
      },
      success: { copy: '{{itemName}} was copied to your Work' },
      archiveFolderModal: {
        body: 'You are about to remove {{folderName}}. Any Folders, $t(common:assignment_plural), or Exams inside of this folder will also be removed. Are you sure you want to proceed?',
        error: 'There was an error removing your folder.',
        assignmentInUse:
          '{{count}} of your Classes is currently practicing Skills from $t(common:assignment_plural) inside of this Folder. If you archive this Folder, your Class will automatically be switched to Spiral Review.',
        assignmentInUse_plural:
          '{{count}} of your Classes are currently practicing Skills from $t(common:assignment_plural) inside of this Folder. If you archive this Folder, your Classes will automatically be switched to Spiral Review.',
        success: 'Removed {{folderName}} and its contents.',
        title: 'Remove Folder',
        undoError: 'There was an error undoing the removal of your folder.',
      },
      duplicate: 'Copy to {{folderName}}',
      inProgress: 'Copying',
      copyTag: {
        confirmation: {
          content:
            'You are about to copy {{itemName}} and all of its contents into your work.',
          title: 'Copy {{type}}?',
        },
        tooltip_workItemClosed: 'Copy {{type}}, {{itemName}}, to My Work',
        tooltip_workItemOpen:
          'Add all Skills from {{itemName}} to {{openWorkItemType}}',
      },
      outdatedCopyTag: {
        content:
          'The exam you are copying was updated. You received a copy of the most recent version.',
        title: 'Updated Version',
      },
      deletedCopyTag: {
        content:
          'That item can no longer be copied because it has been deleted.',
        title: 'Unable to Copy',
      },
      unavailableReloadingTag: {
        content:
          'That item has been changed by the owner. We are reloading the page to reflect the changes.',
        title: 'Item Changed',
      },
      skillDiscovery: {
        emptyState: {
          headline: 'Skills Navigator',
          subheading: 'Start by selecting a grade level or subject.',
        },
      },
      collapseAll: 'Collapse All',
    },
    workDetail: {
      assign: 'Assign',
      name: '$t(common:assignment) Name',
      pointsPerGameCredit: 'Points for Game Credit',
      pointsPerGameCreditHelp:
        'Set a value less than or equal to the $t(common:assignment) Points',
      pointsToFinish: '$t(common:assignment) Points',
      pointsPerSkill: 'Points per Skill',
      skills: 'Skills',
      skill: 'Skill',
      skill_plural: 'Skills',
      spiralReviewProblems: 'Spiral Review Points',
      spiralReviewProblemsTooltip:
        'The number of Spiral Review points that are included in the assignment. We suggest including at least 8 points.',
      totalPoints: 'Total Points',
      defaultAssignmentName: 'New $t(common:assignment)',
      startDisabled: {
        noSkills: 'Skills and Points per Skill are required to start',
        noPoints: 'Points per Skill is required to start',
        noSkillsOrPoints:
          'Skills or Spiral Review problems are required to start',
      },
      editingAssignment: {
        assignedToClassWarning:
          'You have already given this $t(common:assignment) to {{count}} Class. Saving changes will also update the $t(common:assignment) for that Class.',
        assignedToClassWarning_plural:
          'You have already given this $t(common:assignment) to {{count}} Classes. Saving changes will also update the $t(common:assignment) for those Classes.',
        assignedToClassModalWarning:
          '{{assignmentName}} will be updated and any new Skills will be added to Spiral Review for the following Class, potentially affecting $t(common:assignment) completion reports. Do you want to proceed?',
        assignedToClassModalWarning_plural:
          '{{assignmentName}} will be updated and any new Skills will be added to Spiral Review for the following Classes, potentially affecting $t(common:assignment) completion reports. Do you want to proceed?',
        proTip:
          'Pro-tip: Limit your choices to 3 $t(common:skill_plural) and less than 15 points to ensure that your students have time to work in $t(common:mixedReview)',
      },
      error: {
        nameRequired: '$t(common:assignment) Name is required',
        duplicateAssignment: '$t(common:assignment) name already exists.',
        tooManyPoints:
          'Points per Skill is too high or there are too many Skills.',
        recommendation:
          'We recommend that your $t(common:assignment) Points be divisible by the number of Skills.',
      },
      update: 'Updated successfully',
      updatePointsPerGameCredit:
        'Points for Game Credit was updated successfully.',
      updatePointsPerGameCreditError:
        'There was an error changing Points for Game Credit.',
      scheduleSuccess:
        '{{assignmentName}} has been successfully scheduled for {{className}}.',
      buttons: {
        assign: 'Assign',
        cancel: 'Cancel',
        close: 'Close Work',
        doNow: 'Start',
        preview: 'Preview',
        proceed: 'Proceed',
        settings: 'Work Settings',
        update: 'Update',
      },
      modal: {
        assignDisabled: 'This assignment has already been given to this Class.',
        assignDisabled_alt:
          'This class needs to be assigned Skills before it can work on Spiral Review.',
        assignError: 'There was an error starting your $t(common:assignment).',
        assignSuccess: {
          hasNewSkills:
            '{{className}} is now practicing {{assignmentName}}. New Skills were added to Spiral Review.',
          noNewSkills: '{{className}} is now practicing {{assignmentName}}.',
        },
        className: 'Class Name',
        classStatus: 'Default $t(common:assignment)',
        classStatus_old: 'Current Status',
        dateAssigned: 'Previously Assigned',
        doNowHeader: 'Start',
        emptyState: {
          header: "Let's create a class",
          subheader: 'Classes can be made in the classes view.',
          classesLink: 'Take me there!',
          tooltip: 'You must create a Class first',
        },
        newSkillTypes: 'New Skill Type',
        newSkillTypes_plural: 'New Skill Types',
        releaseDate: 'Release Date',
        setStartTime: 'Set Start Date & Time',
        table: { name: 'Assign' },
        updateMixedReview: 'Update Spiral Review',
      },
      emptyState: {
        headline: 'Add Some Skills',
        subheading:
          'Access all Skills from the Skill Bank Navigator on the right.',
      },
      unsavedChanges: {
        content:
          'You have unsaved changes for this $t(common:exercise, { "context": "{{exerciseType}}" }).',
        title: 'Discard unsaved changes?',
        assignment: 'You have unsaved changes for this $t(common:assignment).',
        examTemplate: 'You have unsaved changes for this Exam.',
        negative: 'Cancel',
        affirmative: 'Discard',
        title_copyFolder: 'Discard unsaved changes?',
        negative_copyFolder: 'Cancel',
        affirmative_copyFolder: 'Discard',
        message_copyFolder:
          'You have unsaved changes for this $t(common:assignment). If you continue, {{folderName}} and all of its contents will be copied into your work and changes to this $t(common:assignment) will be discarded.',
        title_copyAssignment: 'Discard unsaved changes?',
        negative_copyAssignment: 'Cancel',
        affirmative_copyAssignment: 'Discard',
        message_copyAssignment:
          'You have unsaved changes for this $t(common:assignment).  If you continue, changes to this $t(common:assignment) will be discarded and {{assignmentName}} will be copied into your work.',
      },
      assignmentInUseModal: {
        title: '$t(common:assignment) Currently In Use',
        basecontent:
          '{{count}} of your Classes {{is}} currently practicing Skills from this $t(common:assignment). If you remove the remaining Skill, your {{class}} will automatically be switched to Spiral Review. Do you want to proceed?',
        content:
          "$t(workDetail:assignmentInUseModal.basecontent, { 'is': 'is', 'class': 'class' })",
        content_plural:
          "$t(workDetail:assignmentInUseModal.basecontent, { 'is': 'are', 'class': 'classes' })",
      },
      assignmentMenu: {
        archive: 'Remove',
        changePointsPerGameCredit: 'Change Points for Game Credit',
        changePointsPerGameCreditDisabledTooltip:
          'You must set Points per Skill first.',
        print: {
          noSkills:
            'You must add some Skills to the $t(common:assignment) first.',
        },
      },
      printExamTemplateModal: {
        error: 'There was an error printing the Exam. Please try again.',
        includeAnswerKey: 'Include Answer Key',
        title: 'Print Practice Exam Options',
      },
      printAssignmentModal: {
        customOption: 'Change the number of problems on the worksheet.',
        error: 'There was an error creating your Worksheet. Please try again.',
        invalid_tooMany:
          'You cannot have more than 100 problems on a Worksheet.',
        problemsPerSkill: 'Number of each Skill',
        shuffle: 'Shuffle',
        shuffle_tooltip: 'Display problems in random order.',
        versions: 'Versions',
        versions_tooltip: 'Each version will have unique problems.',
        title: 'Targeted $t(common:skill_plural) Worksheet',
        title_tooltip:
          'Worksheets only include Targeted $t(common:skill_plural). Learn how to print $t(common:mixedReview) problems <0>here</0>.',
        total: 'Total Problems',
        questionTypesHelperText:
          'Any disabled question types for your classes will still be printed',
      },
      examTemplateMenu: {
        archive: 'Remove',
        print: { noSkills: 'You must add some Skills to the Exam first.' },
      },
      gameCreditModal: { title: 'Set Points for Game Credit' },
      archiveExerciseModal: {
        assignmentInUse:
          'You have given this $t(common:assignment) to {{count}} of your Classes.  If you remove this Assignment, any students working on it will automatically be switched to Spiral Review.',
        body: 'You are about to remove {{name}}. Are you sure you want to proceed?',
        error:
          'There was an error removing your $t(common:exercise, { "context": "{{exerciseType}}" })',
        removeSkillsCheckbox:
          'Also remove this Assignment’s Skills from Spiral Review.',
        success: 'Removed {{name}}.',
        title: 'Remove $t(common:exercise, { "context": "{{exerciseType}}" })',
        undoError:
          'There was an error undoing the removal of your $t(common:exercise, { "context": "{{exerciseType}}" }).',
      },
      examTemplates: {
        helperText: {
          static_false: 'GMM will choose random problems for each student.',
          static_true:
            'Expand a skill and hit refresh until you see a problem you like.',
        },
        name: 'Exam Name',
        static_false: 'Each student gets <strong>random</strong> problems.',
        static_true:
          'Each student gets the <strong>same</strong> problems. You can choose them below.',
        problemCount: '{{count}} Problem',
        problemCount_plural: '{{count}} Problems',
        publish: 'Publish',
        publish_disabled: 'You must add some Skills to the Exam first.',
        publish_withName: 'Publish: {{examName}}',
        publish_noClasses: 'You must create a Class first',
        publishModal: {
          class: { name: 'Class Name' },
          publish: {
            main: 'Publish',
            main_helperText:
              'Makes this Exam available for the selected class(es)',
            disabled:
              'This Exam has already been published to {{className}}. If you wish to publish changes, please delete the published Exam from {{className}} first.',
          },
          shuffle: {
            main: 'Shuffle',
            main_helperText:
              'Randomly shuffles the order in which your students see Exam problems',
          },
          success:
            '{{examName}} is being published to your class. It may take a minute or two before the Exam is visible to your students.',
          success_plural:
            '{{examName}} is being published to your classes. It may take a minute or two before the Exam is visible to your students.',
          error: 'There was an error publishing your Exam.',
        },
        success: { edit: 'Updated successfully' },
        tooManyProblems:
          'You cannot add more than {{max}} problems to an exam.',
        errors: {
          requiredName: 'Exam Name is required',
          duplicateName: 'Exam Name already exists',
          create: 'There was an error saving your Exam.',
          edit: 'There was an error updating your Exam.',
        },
        skillInstances: 'Instances of skill',
      },
      addBySkillIdModal: {
        addSkill: 'Add $t(common:skill)',
        inputLabel: '$t(common:skill) ID',
        menuButton: 'Add $t(common:skill) ID to $t(common:assignment)',
        notFound:
          'We could not find that $t(common:skill) ID.  Please check the number and try again.',
        title: 'Add $t(common:skill) by ID',
      },
      forms: {
        assignment: '$t(common:assignment) Form',
        exam: '$t(common:exam) Form',
      },
      tooltip: {
        removingAllSkills:
          'You must add some $t(common:skill_plural) to this $t(common:assignment) before saving.',
      },
      preview: {
        save: 'You must save first',
        noSkills: 'You must add some $t(common:skill_plural) first',
        error:
          'There was an error with previewing your $t(common:assignment).  Please try again.',
      },
      skillList: 'Skills for {{name}}',
    },
    worksheets: {
      generateButton: {
        confirm: 'Print PDF',
        confirm_generate: 'Generate',
        confirm_generating: 'Generating...',
      },
    },
  },
};
